import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import axios from "axios";
import "./App.css";
import "./services/axiosInterceptors";
import RouteWrapper from "./RouteWrapper";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Toaster } from "./components/common/ui/toaster";

function isAuthError(error: unknown) {
  if (!axios.isAxiosError(error)) {
    return false;
  }

  const data = error.response?.data;
  const message = [data?.detail, data?.code, data?.message, JSON.stringify(data || "")]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return (
    error.response?.status === 401 ||
    message.includes("token_not_valid") ||
    message.includes("token not valid") ||
    message.includes("token is invalid or expired") ||
    message.includes("given token not valid")
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (isAuthError(error)) {
          return false;
        }

        return failureCount < 2;
      },
    },
  },
});

// ============================================================
// MAINTENANCE MODE — set to `false` when APIs are back online
// ============================================================
const MAINTENANCE_MODE = false;

function MaintenancePage() {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem",
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        color: "#e2e8f0",
        fontFamily: "'Poppins', Arial, sans-serif",
        textAlign: "center",
      }}
    >
      <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>🔧</div>
      <h1
        style={{
          fontSize: "2rem",
          fontWeight: 700,
          marginBottom: "0.75rem",
          color: "#f8fafc",
        }}
      >
        We&apos;ll Be Right Back
      </h1>
      <p
        style={{
          fontSize: "1.1rem",
          maxWidth: "480px",
          lineHeight: 1.6,
          color: "#94a3b8",
          marginBottom: "1.5rem",
        }}
      >
        We&apos;re currently performing scheduled maintenance to improve your
        experience. Please check back shortly.
      </p>
      <div
        style={{
          padding: "0.75rem 1.5rem",
          borderRadius: "8px",
          background: "rgba(99,102,241,0.15)",
          border: "1px solid rgba(99,102,241,0.3)",
          color: "#818cf8",
          fontSize: "0.9rem",
        }}
      >
        Estimated downtime: a few hours
      </div>
    </div>
  );
}

function App() {
  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <div className="App">
      {/* {isMobile ? (
        <h6
          style={{
            height: "100vh",
            width: "100vw",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
            color: "#707070",
            textAlign: "center",
          }}
        >
          This content is temporarily not available in mobile view.
        </h6>
      ) : ( */}
        <QueryClientProvider client={queryClient}>
          <RouteWrapper />
          <ToastContainer />
          <ReactQueryDevtools />
          <Toaster />
        </QueryClientProvider>
      
    </div>
  );
}
export default App;
